import { styled } from '../../Styles/stitches.config'

export const StyledCheckbox = styled('label', {
    bgc: '$neutral100',
    border: '1px solid $primary600',
    br: '$1',
    cursor: 'pointer',
    display: 'inline-block',
    position: 'relative',
    size: 20,
    transition: '$default',

    '&::after': {
        bc: '$neutral100',
        borderStyle: 'solid',
        borderWidth: '0 2px 2px 0',
        content: `''`,
        display: 'none',
        h: 14,
        left: 6,
        position: 'absolute',
        top: 1,
        transform: 'rotate(45deg)',
        transition: '$default',
        w: 6,
    },

    variants: {
        error: {
            true: {
                bc: '$error600 !important',
                bgc: '$error400 !important',

                '&::after': {
                    bc: '$error600 !important',
                },
            },
        },
    },

    defaultVariants: { error: false },
})
